import React, { useEffect, useState } from "react";
import DragAndDrop from "./DragAndDrop";
import { RotatingSquare } from "react-loader-spinner";

const HomeMarketsDragAndDrop = () => {
  // const [data, setData] = useState([]);
  // const [loading, setLoading] = useState(true);
  // useEffect(() => {
  //   fetch(`https://api.wlfmobile.com/api/admin/popular/market/view/without/paginate`, {
  //     method: "GET",
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setData(data.data);
  //       setLoading(false);
  //     });
  // }, []);





  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    Promise.all([
      fetch("https://api.wlfmobile.com/api/admin/crypto/currency/view/without/paginate").then(res => res.json()),
      fetch("https://api.wlfmobile.com/api/admin/forex/view/without/paginate").then(res => res.json()),
      fetch("https://api.wlfmobile.com/api/admin/metals/view/without/paginate").then(res => res.json()),
      fetch("https://api.wlfmobile.com/api/admin/stocks/view/without/paginate").then(res => res.json())
    ])
      .then(([cryptoRes, forexRes, metalRes, stockRes]) => {


        setData([
          ...cryptoRes.data.map(item => ({
            ...item,
            market: "Crypto"
          })),
          ...metalRes.data.map(item => ({
            ...item,
            market: "Metal"
          })),
          ...forexRes.data.map(item => ({
            ...item,
            market: "Forex"
          })),
          ...stockRes.data.map(item => ({
            ...item,
            market: "Stock"
          }))
        ]);

        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);


  const [FilterData, setFilterData] = useState([]);

  const [FilterDataLoading, setFilterDataLoading] = useState(true);
  useEffect(() => {
    fetch(`https://api.wlfmobile.com/api/admin/home/market/filter/view`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data)
        setFilterData(data.data);
        setFilterDataLoading(false);

      });
  }, []);

  const marketKeys = [
    "crypto_market_id",
    "forex_market_id",
    "metal_market_id",
    "stock_market_id",
  ];

  const CryptoCurrencyData = data.filter((el) => {
    const filter = FilterData.some((item) =>
      marketKeys.some((key) => item[key] === el._id)
    );
    if (!filter) {
      return true;
    }
  });


  let CryptoCurrencyFilterData = [];
  for (let item of FilterData) {
    for (let filterItem of data) {
      if ((item.crypto_market_id || item.forex_market_id  || item.metal_market_id  || item.stock_market_id)  === filterItem._id) {
        CryptoCurrencyFilterData.push(filterItem);
        break;
      }

    }
  }


  if (loading || FilterDataLoading) {
    return (
      <>
        <div className="loader-css">
          <RotatingSquare
            visible={true}
            height="100"
            width="100"
            color="#4fa94d"
            ariaLabel="rotating-square-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
      </>
    );
  }

  return (
    <>
      <DragAndDrop data={CryptoCurrencyData} FilterData={CryptoCurrencyFilterData} />
    </>
  );
};
export default HomeMarketsDragAndDrop;
